












import Vue from 'vue';
import Component from 'vue-class-component';
import NavigationDrawer from '@/components/NavigationDrawer.vue';
import MainHeader from '@/components/MainHeader.vue';
import { Action } from 'vuex-class';

@Component({
  components: {
    NavigationDrawer,
    MainHeader,
  },
})

export default class Default extends Vue {
  @Action('fetchDirectory', { namespace: 'directory' })
  fetchDirectory: any;

  beforeMount() {
    this.fetchDirectory({ commitName: 'setPlatforms', pimCoreClassName: 'PlantsHR' });
    this.fetchDirectory({ commitName: 'setCostCenters', pimCoreClassName: 'CostCenter' });
    this.fetchDirectory({ commitName: 'setCostAccounts', pimCoreClassName: 'CostAccountNEW' });
  }
}
